<template>
    <div class="extend_box animate__animated animate__fadeIn">
        <div class="extend">
            <div class="search_box">

                <div class="box_line">
                    <div class="title_txts">项目编码：</div>
                    <input type="text" class="input_box" placeholder="请输入铜仁市建委项目编码" v-model="formData.gztrProjectCode"/>
                </div>
                <div class="box_line">
                    <div class="search-btn" @click="fnAddOrEdit" type="primary"><span>保 存</span></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import request from '@/utils/request';

    export default {
        data() {
            return {
                key_group: {},
                formData: {
                    gztrProjectCode: '',
                }
            };
        },
        created() {
            this.fnGroup();
            console.log('created...');
        },
        methods: {
            fnGroup() {
                request({
                    url: 'project/getProjectInfo',
                    method: 'GET'
                })
                    .then(res => {
                        this.key_group = JSON.parse(res.data.key_group);
                        for (let _key in this.formData) {
                            this.formData[_key] = this.key_group[_key];
                        }
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            fnAddOrEdit() {

                for (let _key in this.formData) {
                    if (!this.formData[_key]) {
                        console.log(_key);
                        this.$message.warning('参数不能为空');
                        return;
                    }

                    this.key_group[_key] = this.formData[_key];
                }
                let _data = JSON.stringify(this.key_group) !== '[]' ? JSON.stringify(this.key_group) : JSON.stringify(this.formData);

                request({
                    url: 'project/editProject',
                    method: 'POST',
                    data: {
                        key_group: _data
                    }
                })
                    .then(res => {
                        this.$message.success(res.data);
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            }
        }
    };
</script>
<style lang="scss" scoped>
    @import '~@/styles/mixin.scss';
    .extend_box {
        width: 1920px;
        height: 858px;
        position: relative;
        overflow: hidden;
        .extend {
            position: absolute;
            left: 0;
            right: -20px;
            top: 0;
            bottom: 0;
            overflow-x: hidden;
            overflow-y: auto;
        }
    }
    .search_box {
        height: 148px;
        width: 1880px;
        margin-top: 100px;
        margin-left: 20px;
        .box_line {
            width: 1880px;
            height: 72px;
            margin-bottom: 10px;
            @include flex-box(center, center);
            .title_txts {
                width: 170px;
                color: #fff;
                font-size: 18px
            }
            .input_box {
                width: 311px;
                height: 40px;
                line-height: 30px;
                padding-left: 15px;
                color: rgba(77, 180, 244, 0.7);
                font-size: 12px;
                border-radius: 5px;
                outline: none;
                background-color: rgba(77, 180, 244, 0.2);
                border: none;
                &::-webkit-input-placeholder {
                    color: rgba(77, 180, 244, 0.7);
                }
                &::-moz-placeholder { /* Mozilla Firefox 19+ */
                    color: rgba(77, 180, 244, 0.7);
                }
                &:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
                    color: rgba(77, 180, 244, 0.7);
                }
                &:-ms-input-placeholder { /* Internet Explorer 10-11 */
                    color: rgba(77, 180, 244, 0.7);
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/ProjectExtend/projectExtendGztr/index.vue